jQuery( function ($) {

    $(document).on( 'click', '.loop-atc .adjust-qty', function () {
        const adjustment = parseInt( $(this).data( 'value' ) );
        const $input = $(this).closest( '.loop-atc' ).find( '.loop-atc-qty' ).first();
        let value = parseInt( $input.val() );
        value = Math.max( 1, value + adjustment );
        $input.val( value ).change();
    });

    $(document).on( 'change', '.loop-atc-qty', function () {
        const $atc_group = $(this).closest( '.loop-atc' );
        const $atc_btn = $atc_group.find( '.add_to_cart_button' ).first();
        $atc_btn.attr( 'data-quantity', $(this).val() );
        $atc_group.find( '.decrement' ).prop( 'disabled', ( $(this).val() == $(this).attr('min') ) );
    });


    const $atc_toast = $( '.product-atc-toast' );
    if ( $atc_toast.length ) {
        let active_timeout;
        let visible_timeout;
        const observer = new MutationObserver( ( mutations, observer ) => {
            $atc_toast.addClass( 'active visible' );
            active_timeout = setTimeout( () => {
                $atc_toast.removeClass( 'active' );
            }, 5000 );
            visible_timeout = setTimeout( () => {
                $atc_toast.removeClass( 'visible' );
            }, 5500 );
        });
        observer.observe( $atc_toast.get(0), {
            childList: true,
            subtree: false,
            attributes: false,
        });
    }

});